/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtpMailRegReq } from '../../models/otp-mail-reg-req';
import { OtpRes } from '../../models/otp-res';

export interface ApiUserRegisterOtpMailPost$Params {
      body?: OtpMailRegReq
}

export function apiUserRegisterOtpMailPost(http: HttpClient, rootUrl: string, params?: ApiUserRegisterOtpMailPost$Params, context?: HttpContext): Observable<StrictHttpResponse<OtpRes>> {
  const rb = new RequestBuilder(rootUrl, apiUserRegisterOtpMailPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OtpRes>;
    })
  );
}

apiUserRegisterOtpMailPost.PATH = '/api/User/register-otp-mail';
